// extracted by mini-css-extract-plugin
export var activeDot = "_4a-c";
export var buttonContainer = "_4a-9";
export var channelButton = "_4a-a";
export var clickable = "_4a-d";
export var content = "_4a-0";
export var contentFull = "_4a-2";
export var contentThird = "_4a-1";
export var contentWrapper = "_4a-7";
export var description = "_4a-5";
export var heightShort = "_4a-f";
export var image = "_4a-3";
export var imageContainer = "_4a-4";
export var selectButton = "_4a-e";
export var spinnerContainer = "_4a-b";
export var titleContent = "_4a-8";
export var titleWrapper = "_4a-6";